
// // import { useEffect, useState } from "react";
// // import axios from "axios";
// // import { registerVendor } from "../../../Service/Engineeringservicefil";
// // import { useLoader } from "../../../context/LoaderProvider";

// // const PreviewCard = ({ formData, onBack }) => {
// //     const { showLoader, hideLoader } = useLoader();
// //     const [apiData, setApiData] = useState(null);
// //     const [editMode, setEditMode] = useState(false);
// //     const [editedData, setEditedData] = useState({});
// //     console.log(localStorage);

// //     const isAlreadySaved = apiData && Object.keys(apiData).length > 0;
// //     const data = apiData || formData;
// //     // Initialize editedData when data changes
// //     useEffect(() => {
// //         if (data) {
// //             setEditedData(data);
// //         }
// //     }, [data]);

// //     const handleInputChange = (field, value) => {
// //         setEditedData(prev => ({
// //             ...prev,
// //             [field]: value
// //         }));
// //     };

// //     const handleSave = async () => {
// //         try {
// //             const vendorId = localStorage.getItem("vendorId");
// //             showLoader();
// //             const validVendorTypes = ["Restaurant", "FashionStore", "Hotel", "BanquetHall"];
// //             // 🔥 CREATE FORM DATA variations of the code that data
// //             const formDataToSend = new FormData();

// //             // ✅ JSON DATA
// //             const vendorData = {
// //                 vendorId: Number(vendorId),

// //                 // LOCATION
// //                 latitude: Number(editedData.latitude) || 0,
// //                 longitude: Number(editedData.longitude) || 0,
// //                 fullAddress: editedData.address || "",
// //                 addressLine: editedData.addressLine || "",
// //                 doorNumber: editedData.doorNumber || "",
// //                 landMark: editedData.landMark || "",
// //                 city: editedData.city || "",
// //                 state: editedData.state || "Telangana",
// //                 pincode: Number(editedData.pincode) || 0,

// //                 // COMPANY
// //                 companyName: editedData.companyName || "",
// //                 registeredName: editedData.companyName || "",
// //                 ownerName: editedData.companyName || "",
// //                 businessVertical: editedData.businessVertical?.trim() || "ENGINEERING_SERVICE",
// //                 position: editedData.position || "",
// //                 vendorType: validVendorTypes.includes(editedData.vendorType)
// //                     ? editedData.vendorType
// //                     : "Restaurant",

// //                 // CONTACT
// //                 holderName: editedData.contactName || "",
// //                 mobileNumber: editedData.phone || "",
// //                 email: editedData.email || "",

// //                 // DOCUMENTS
// //                 aadharNumber: editedData.aadhar || "",
// //                 panCardNumber: editedData.pan || "",
// //                 gstNumber: editedData.gst || "",

// //                 // LICENSES
// //                 tradeLicenseNumber: editedData.tradeLicenseNo || "",
// //                 tradeLicenseStartDate: editedData.tradeStart || "",
// //                 tradeLicenseEndDate: editedData.tradeEnd || "",

// //                 labourLicenseNumber: editedData.labourLicenseNo || "",
// //                 labourStartDate: editedData.labourStart || "",
// //                 labourEndDate: editedData.labourEnd || "",

// //                 bankAccountNumber: editedData.accountNumber || "",
// //                 ifscCode: editedData.ifsc || "",
// //                 bankName: editedData.bankName || "",
// //                 branchName: editedData.bankName || "",
// //                 // FLAGS
// //                 aadharNumberStatus: false,
// //                 panCardStatus: false,
// //                 registeredDocumentsStatus: false,
// //                 gstNumberStatus: false,
// //                 tradeLicenseStatus: false,
// //                 labourLicenseStatus: false,

// //                 typeStatus: false,
// //                 bankDetailsEditable: false,
// //                 addressEditable: false,
// //                 panCardEditable: false,
// //                 labourLicenseEditable: false,
// //                 aadharNumberEditable: false,
// //                 registeredNameStatus: false,
// //                 businessPlanStatus: false,
// //                 blankChequeStatus: false,
// //                 online: false,
// //                 mobileNumberStatus: false,
// //                 emailStatus: false
// //             };

// //             // 🔥 APPEND JSON
// //             formDataToSend.append(
// //                 "vendorData",
// //                 new Blob([JSON.stringify(vendorData)], { type: "application/json" })
// //             );

// //             // 🔥 APPEND FILES
// //             if (editedData.aadharFile) {
// //                 formDataToSend.append("aadharPhotoFront", editedData.aadharFile);
// //             }

// //             if (editedData.panFile) {
// //                 formDataToSend.append("panCard", editedData.panFile);
// //             }
// //             if (editedData.passbookFile) {
// //                 formDataToSend.append("passbook", editedData.passbookFile);
// //             }
// //             if (editedData.labourFile) {
// //                 formDataToSend.append("labourLicense", editedData.labourFile);
// //             }
// //             if (editedData.tradeLicenseFile) {
// //                 formDataToSend.append("tradeLicense", editedData.tradeLicenseFile);
// //             }

// //             // 🚀 API CALL
// //             const res = await registerVendor(vendorId, formDataToSend);

// //             alert("✅ Vendor Registered Successfully");
// //             window.location.reload();

// //         } catch (err) {
// //             console.error(err);
// //             alert("❌ Failed to register vendor");
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     useEffect(() => {
// //         const fetchVendor = async () => {
// //             try {
// //                 const vendorId = localStorage.getItem("vendorId");

// //                 console.log("🔍 Fetching engineering vendor with ID:", vendorId);

// //                 if (!vendorId) {
// //                     console.error("❌ No vendorId found in localStorage!");
// //                     return;
// //                 }

// //                 // ✅ USE ENGINEERING SERVICE API
// //                 const res = await axios.get(
// //                     `https://backend.maamaas.com/engineering/api/get/vendor-registration/${vendorId}`
// //                 );

// //                 console.log("📦 Engineering API Response:", res.data);

// //                 const data = res.data;

// //                 // Map the response data to your form fields based on ACTUAL field names
// //                 setApiData({
// //                     // Company Details
// //                     companyName: data.companyName || "",
// //                     businessVertical: data.businessVertical || "Engineering Services",
// //                     position: data.position || "",
// //                     verticalType: data.vendorType || "",
// //                     vendorType: data.vendorType || "Restaurant",

// //                     // Address Details
// //                     address: data.fullAddress || "",
// //                     addressLine: data.addressLine || "",
// //                     doorNumber: data.doorNumber || "",
// //                     landMark: data.landMark || "",
// //                     city: data.city || "",
// //                     state: data.state || "",
// //                     pincode: data.pincode || "",
// //                     latitude: data.latitude || "",
// //                     longitude: data.longitude || "",

// //                     // Contact Details
// //                     contactName: data.holderName || "",
// //                     phone: data.mobileNumber || "",
// //                     email: data.email || "",

// //                     // Documents
// //                     aadhar: data.aadharNumber || "",
// //                     aadharPreview: data.aadharPhotoFront || "",

// //                     pan: data.panCardNumber || "",
// //                     panFilePreview: data.panCard || "",

// //                     gst: data.gstNumber || "",
// //                     gstFilePreview: data.gstFile || "",

// //                     // Trade License
// //                     tradeLicenseNo: data.tradeLicenseNumber || "",
// //                     tradeStart: data.tradeLicenseStartDate || "",
// //                     tradeEnd: data.tradeLicenseEndDate || "",
// //                     tradeLicenseFilePreview: data.tradeLicense || "",

// //                     // Labour License
// //                     labourLicenseNo: data.labourLicenseNumber || "",
// //                     labourStart: data.labourStartDate || "",
// //                     labourEnd: data.labourEndDate || "",
// //                     labourFilePreview: data.labourLicense || "",

// //                     // Bank Details
// //                     bankName: data.bankName || "",
// //                     ifsc: data.ifscCode || "",
// //                     accountNumber: data.bankAccountNumber || "",
// //                     passbookFilePreview: data.passbook || "",
// //                 });

// //                 console.log("✅ Mapped Data Successfully");

// //             } catch (err) {
// //                 console.error("❌ Error fetching engineering vendor data:", err);
// //                 if (err.response?.status === 404) {
// //                     console.log("No existing data found - this is a new registration");
// //                 }
// //             }
// //         };

// //         fetchVendor();
// //     }, []);

// //     return (
// //         <div style={card}>
// //             <div style={previewBox}>
// //                 {/* Edit Mode Toggle Button */}
// //                 <div style={{ textAlign: "right", marginBottom: "15px" }}>
// //                     <button
// //                         onClick={() => setEditMode(!editMode)}
// //                         style={{
// //                             background: editMode ? "#6b7280" : "#3b82f6",
// //                             color: "#fff",
// //                             padding: "6px 15px",
// //                             borderRadius: "6px",
// //                             border: "none",
// //                             cursor: "pointer",
// //                             fontSize: "12px"
// //                         }}
// //                     >
// //                         {editMode ? "View Mode" : "Edit Mode"}
// //                     </button>
// //                 </div>

// //                 {/* COMPANY DETAILS */}
// //                 {(data.companyName || data.businessVertical || data.position || data.verticalType || data.address) && (
// //                     <>
// //                         <h4 style={title}>Company Details</h4>

// //                         <div style={formGridRow}>
// //                             <div style={formField}>
// //                                 <label style={formLabel}>Company</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.companyName || ""}
// //                                         onChange={(e) => handleInputChange("companyName", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.companyName}</div>
// //                                 )}
// //                             </div>

// //                             <div style={formField}>
// //                                 <label style={formLabel}>Vertical</label>
// //                                 {editMode ? (
// //                                     <select
// //                                         value={editedData.businessVertical || "ENGINEERING_SERVICE"}
// //                                         onChange={(e) => handleInputChange("businessVertical", e.target.value)}
// //                                         style={formInput}
// //                                     >
// //                                         <option value="ENGINEERING_SERVICE">Engineering Service</option>
// //                                         {/* <option value="FOOD_AND_BEVERAGES">Food And Beverages</option> */}

// //                                     </select>
// //                                 ) : (
// //                                     <div style={formInputView}>{data.businessVertical || "Engineering Service"}</div>
// //                                 )}
// //                             </div>

// //                             <div style={formField}>
// //                                 <label style={formLabel}>Position</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.position || ""}
// //                                         onChange={(e) => handleInputChange("position", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.position}</div>
// //                                 )}
// //                             </div>
// //                         </div>

// //                         <div style={formGridRow}>
// //                             <div style={formField}>
// //                                 <label style={formLabel}>Type</label>
// //                                 {editMode ? (
// //                                     <select
// //                                         value={editedData.vendorType || "Restaurant"}
// //                                         onChange={(e) => handleInputChange("vendorType", e.target.value)}
// //                                         style={formInput}
// //                                     >
// //                                         <option value="Restaurant">Restaurant</option>
// //                                         <option value="FashionStore">Fashion Store</option>
// //                                         <option value="Hotel">Hotel</option>
// //                                         <option value="BanquetHall">Banquet Hall</option>
// //                                     </select>
// //                                 ) : (
// //                                     <div style={formInputView}>{data.verticalType}</div>
// //                                 )}
// //                             </div>

// //                             <div style={formField}>
// //                                 <label style={formLabel}>Door No</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.doorNumber || ""}
// //                                         onChange={(e) => handleInputChange("doorNumber", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.doorNumber}</div>
// //                                 )}
// //                             </div>

// //                             <div style={formField}>
// //                                 <label style={formLabel}>City</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.city || ""}
// //                                         onChange={(e) => handleInputChange("city", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.city}</div>
// //                                 )}
// //                             </div>
// //                         </div>

// //                         <div style={formGridRow}>
// //                             <div style={formField}>
// //                                 <label style={formLabel}>State</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.state || ""}
// //                                         onChange={(e) => handleInputChange("state", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.state}</div>
// //                                 )}
// //                             </div>

// //                             <div style={formField}>
// //                                 <label style={formLabel}>Pincode</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.pincode || ""}
// //                                         onChange={(e) => handleInputChange("pincode", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.pincode}</div>
// //                                 )}
// //                             </div>

// //                             <div style={formField}>
// //                                 <label style={formLabel}>Landmark</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.landMark || ""}
// //                                         onChange={(e) => handleInputChange("landMark", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.landMark}</div>
// //                                 )}
// //                             </div>
// //                         </div>

// //                         <div style={formGridRow}>
// //                             <div style={formField}>
// //                                 <label style={formLabel}>Latitude</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.latitude || ""}
// //                                         onChange={(e) => handleInputChange("latitude", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.latitude}</div>
// //                                 )}
// //                             </div>

// //                             <div style={formField}>
// //                                 <label style={formLabel}>Longitude</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.longitude || ""}
// //                                         onChange={(e) => handleInputChange("longitude", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.longitude}</div>
// //                                 )}
// //                             </div>

// //                             <div style={formField}></div>
// //                         </div>

// //                         <hr style={divider} />
// //                     </>
// //                 )}

// //                 {/* CONTACT DETAILS */}
// //                 <>
// //                     <h4 style={title}>Contact Details</h4>

// //                     <div style={formGridRow}>
// //                         <div style={formField}>
// //                             <label style={formLabel}>Name</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="text"
// //                                     value={editedData.contactName || ""}
// //                                     onChange={(e) => handleInputChange("contactName", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.contactName}</div>
// //                             )}
// //                         </div>

// //                         <div style={formField}>
// //                             <label style={formLabel}>Phone</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="tel"
// //                                     value={editedData.phone || ""}
// //                                     onChange={(e) => handleInputChange("phone", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.phone}</div>
// //                             )}
// //                         </div>

// //                         <div style={formField}>
// //                             <label style={formLabel}>Email</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="email"
// //                                     value={editedData.email || ""}
// //                                     onChange={(e) => handleInputChange("email", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.email}</div>
// //                             )}
// //                         </div>
// //                     </div>

// //                     <div style={licenseRow}>
// //                         <div style={{ ...licenseItem, flex: "0 0 200px", minWidth: "350px" }}>
// //                             <label style={formLabel}>Aadhar</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="text"
// //                                     value={editedData.aadhar || ""}
// //                                     onChange={(e) => handleInputChange("aadhar", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.aadhar}</div>
// //                             )}
// //                         </div>

// //                         <div style={{ ...fileItem, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "6px" }}>
// //                             <span style={{ ...fileLabel, textAlign: "left" }}>Aadhar File</span>
// //                             {editMode ? (
// //                                 <input
// //                                     type="file"
// //                                     onChange={(e) => handleInputChange("aadharFile", e.target.files[0])}
// //                                     style={fileInput}
// //                                 />
// //                             ) : (
// //                                 <img src={data.aadharPreview} alt="Aadhar" style={imagePreviewSmall} />
// //                             )}
// //                         </div>
// //                     </div>

// //                     <hr style={divider} />
// //                 </>

// //                 {/* LICENSE DETAILS */}
// //                 <>
// //                     <h4 style={title}>Licenses</h4>

// //                     {/* GST and PAN */}
// //                     <div style={licenseRow}>
// //                         <div style={{ ...licenseItem, flex: "0 0 220px", minWidth: "350px" }}>
// //                             <label style={formLabel}>GST No</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="text"
// //                                     value={editedData.gst || ""}
// //                                     onChange={(e) => handleInputChange("gst", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.gst}</div>
// //                             )}

// //                             <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
// //                                 <span style={{ ...fileLabel, textAlign: "left" }}>GST File</span>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="file"
// //                                         onChange={(e) => handleInputChange("gstFile", e.target.files[0])}
// //                                         style={fileInput}
// //                                     />
// //                                 ) : (
// //                                     <img src={data.gstFilePreview} style={imagePreviewSmall} />
// //                                 )}
// //                             </div>
// //                         </div>

// //                         <div style={{ ...licenseItem, flex: "0 0 220px", minWidth: "350px" }}>
// //                             <label style={formLabel}>PAN</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="text"
// //                                     value={editedData.pan || ""}
// //                                     onChange={(e) => handleInputChange("pan", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.pan}</div>
// //                             )}

// //                             <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
// //                                 <span style={{ ...fileLabel, textAlign: "left" }}>PAN File</span>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="file"
// //                                         onChange={(e) => handleInputChange("panFile", e.target.files[0])}
// //                                         style={fileInput}
// //                                     />
// //                                 ) : (
// //                                     <img src={data.panFilePreview} style={imagePreviewSmall} />
// //                                 )}
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* TRADE LICENSE */}
// //                     <>
// //                         <div style={licenseRow}>
// //                             <div style={licenseItem}>
// //                                 <label style={formLabel}>Trade License</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.tradeLicenseNo || ""}
// //                                         onChange={(e) => handleInputChange("tradeLicenseNo", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.tradeLicenseNo}</div>
// //                                 )}
// //                             </div>

// //                             <div style={licenseItem}>
// //                                 <label style={formLabel}>Start Date</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="date"
// //                                         value={editedData.tradeStart || ""}
// //                                         onChange={(e) => handleInputChange("tradeStart", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.tradeStart}</div>
// //                                 )}
// //                             </div>

// //                             <div style={licenseItem}>
// //                                 <label style={formLabel}>End Date</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="date"
// //                                         value={editedData.tradeEnd || ""}
// //                                         onChange={(e) => handleInputChange("tradeEnd", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.tradeEnd}</div>
// //                                 )}
// //                             </div>
// //                         </div>

// //                         <div style={licenseRow}>
// //                             <div style={licenseItem}>
// //                                 <label style={formLabel}>Trade File</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="file"
// //                                         onChange={(e) => handleInputChange("tradeLicenseFile", e.target.files[0])}
// //                                         style={fileInput}
// //                                     />
// //                                 ) : (
// //                                     <img src={data.tradeLicenseFilePreview} style={imagePreview} />
// //                                 )}
// //                             </div>
// //                         </div>
// //                     </>

// //                     {/* LABOUR LICENSE */}
// //                     <>
// //                         <div style={licenseRow}>
// //                             <div style={licenseItem}>
// //                                 <label style={formLabel}>Labour License</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="text"
// //                                         value={editedData.labourLicenseNo || ""}
// //                                         onChange={(e) => handleInputChange("labourLicenseNo", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.labourLicenseNo}</div>
// //                                 )}
// //                             </div>

// //                             <div style={licenseItem}>
// //                                 <label style={formLabel}>Start Date</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="date"
// //                                         value={editedData.labourStart || ""}
// //                                         onChange={(e) => handleInputChange("labourStart", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.labourStart}</div>
// //                                 )}
// //                             </div>

// //                             <div style={licenseItem}>
// //                                 <label style={formLabel}>End Date</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="date"
// //                                         value={editedData.labourEnd || ""}
// //                                         onChange={(e) => handleInputChange("labourEnd", e.target.value)}
// //                                         style={formInput}
// //                                     />
// //                                 ) : (
// //                                     <div style={formInputView}>{data.labourEnd}</div>
// //                                 )}
// //                             </div>
// //                         </div>

// //                         <div style={licenseRow}>
// //                             <div style={licenseItem}>
// //                                 <label style={formLabel}>Labour File</label>
// //                                 {editMode ? (
// //                                     <input
// //                                         type="file"
// //                                         onChange={(e) => handleInputChange("labourFile", e.target.files[0])}
// //                                         style={fileInput}
// //                                     />
// //                                 ) : (
// //                                     <img src={data.labourFilePreview} style={imagePreview} />
// //                                 )}
// //                             </div>
// //                         </div>
// //                     </>

// //                     <hr style={divider} />
// //                 </>

// //                 {/* BANK DETAILS */}
// //                 <>
// //                     <h4 style={title}>Bank Details</h4>

// //                     <div style={licenseRow}>
// //                         <div style={licenseItem}>
// //                             <label style={formLabel}>Bank</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="text"
// //                                     value={editedData.bankName || ""}
// //                                     onChange={(e) => handleInputChange("bankName", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.bankName}</div>
// //                             )}
// //                         </div>

// //                         <div style={licenseItem}>
// //                             <label style={formLabel}>IFSC</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="text"
// //                                     value={editedData.ifsc || ""}
// //                                     onChange={(e) => handleInputChange("ifsc", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.ifsc}</div>
// //                             )}
// //                         </div>

// //                         <div style={licenseItem}>
// //                             <label style={formLabel}>Account</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="text"
// //                                     value={editedData.accountNumber || ""}
// //                                     onChange={(e) => handleInputChange("accountNumber", e.target.value)}
// //                                     style={formInput}
// //                                 />
// //                             ) : (
// //                                 <div style={formInputView}>{data.accountNumber}</div>
// //                             )}
// //                         </div>
// //                     </div>

// //                     <div style={licenseRow}>
// //                         <div style={licenseItem}>
// //                             <label style={formLabel}>Passbook File</label>
// //                             {editMode ? (
// //                                 <input
// //                                     type="file"
// //                                     onChange={(e) => handleInputChange("passbookFile", e.target.files[0])}
// //                                     style={fileInput}
// //                                 />
// //                             ) : (
// //                                 <img src={data.passbookFilePreview} style={imagePreview} />
// //                             )}
// //                         </div>
// //                     </div>

// //                     <hr style={divider} />
// //                 </>

// //                 <div style={{
// //                     display: "flex",
// //                     justifyContent: "center",
// //                     alignItems: "center",
// //                     gap: "10px",
// //                     marginTop: "20px"
// //                 }}>
// //                     {/* Back Button */}
// //                     <button
// //                         onClick={onBack}
// //                         style={{
// //                             background: "#6b7280",
// //                             color: "#fff",
// //                             padding: "8px 20px",
// //                             borderRadius: "8px",
// //                             border: "none",
// //                             cursor: "pointer"
// //                         }}
// //                     >
// //                         ← Back
// //                     </button>

// //                     {/* Save Button */}
// //                     <button
// //                         style={{
// //                             ...saveBtn,
// //                             background: isAlreadySaved && !editMode ? "#9ca3af" : "#22c55e",
// //                             cursor: isAlreadySaved && !editMode ? "not-allowed" : "pointer",
// //                             opacity: isAlreadySaved && !editMode ? 0.7 : 1
// //                         }}
// //                         onClick={!isAlreadySaved || editMode ? handleSave : undefined}
// //                         disabled={isAlreadySaved && !editMode}
// //                     >
// //                         {isAlreadySaved && !editMode ? "Saved" : "Save"}
// //                     </button>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default PreviewCard;

// // // Styles
// // const width = window.innerWidth;
// // const footer = {
// //     padding: "16px",
// //     borderTop: "1px solid #e5e7eb",
// //     textAlign: "center"
// // };

// // const saveBtn = {
// //     background: "#22c55e",
// //     color: "#fff",
// //     padding: "10px 30px",
// //     borderRadius: "8px",
// //     border: "none",
// //     fontWeight: "600",
// //     cursor: "pointer",
// //     fontSize: "14px",
// //     transition: "0.2s"
// // };

// // const title = {
// //     fontSize: "13px",
// //     fontWeight: "600",
// //     marginBottom: "10px",
// //     color: "#111827"
// // };

// // const divider = {
// //     margin: "10px 0",
// //     border: "none",
// //     borderTop: "1px solid #e5e7eb"
// // };

// // const header = {
// //     padding: "12px",
// //     textAlign: "center",
// //     fontWeight: "600",
// //     fontSize: "15px",
// //     borderBottom: "1px solid #e5e7eb"
// // };

// // const row = {
// //     display: "flex",
// //     justifyContent: "space-between",
// //     alignItems: "center",
// //     marginBottom: "10px",
// //     fontSize: "13px"
// // };

// // const label = {
// //     fontSize: "13px",
// //     color: "#6b7280"
// // };

// // const greenBox = {
// //     background: "#dcfce7",
// //     color: "#15803d",
// //     padding: "5px 10px",
// //     borderRadius: "8px",
// //     fontSize: "12px"
// // };

// // const orangeBox = {
// //     background: "#ffedd5",
// //     color: "#c2410c",
// //     padding: "5px 10px",
// //     borderRadius: "8px",
// //     fontSize: "12px"
// // };

// // const previewBox = {
// //     borderRadius: "10px",
// //     padding: "20px",
// //     textAlign: "center",
// //     color: "#6b7280"
// // };

// // const valueBox = {
// //     background: "#e0ecff",
// //     color: "#2563eb",
// //     padding: "5px 10px",
// //     borderRadius: "8px",
// //     fontSize: "12px",
// //     fontWeight: "500"
// // };

// // const card = {
// //     background: "#fff",
// //     borderRadius: "12px",
// //     margin: "10px",
// // };

// // const imagePreview = {
// //     width: "60px",
// //     height: "60px",
// //     objectFit: "cover",
// //     borderRadius: "8px",
// //     border: "1px solid #e5e7eb"
// // };

// // const gridRow = {
// //     display: "flex",
// //     gap: "12px",
// //     marginBottom: "10px",
// //     flexWrap: "wrap"
// // };

// // const gridItem = {
// //     flex: "1 1 30%",
// //     minWidth: "180px",
// //     display: "flex",
// //     justifyContent: "space-between",
// //     alignItems: "center",
// //     background: "#f9fafb",
// //     padding: "8px 10px",
// //     borderRadius: "8px",
// //     border: "1px solid #e5e7eb"
// // };

// // const formGridRow = {
// //     display: "flex",
// //     gap: "8px",
// //     marginBottom: "14px",
// //     flexWrap: "wrap",
// //     width: "100%",
// // };

// // const formField = {
// //     flex: "1 1 30%",
// //     minWidth: "220px",
// //     display: "flex",
// //     flexDirection: "column",
// //     alignItems: "flex-start"
// // };

// // const formLabel = {
// //     fontSize: "12px",
// //     fontWeight: "600",
// //     marginBottom: "5px",
// //     color: "#374151",
// //     textAlign: "left",
// //     width: "100%"
// // };

// // const formInputView = {
// //     width: "100%",
// //     minHeight: "38px",
// //     padding: "9px 10px",
// //     borderRadius: "8px",
// //     border: "1px solid #d1d5db",
// //     background: "#f9fafb",
// //     fontSize: "13px",
// //     textAlign: "left"
// // };

// // const formInput = {
// //     width: "100%",
// //     minHeight: "38px",
// //     padding: "8px 10px",
// //     borderRadius: "8px",
// //     border: "1px solid #d1d5db",
// //     fontSize: "13px",
// //     fontFamily: "inherit"
// // };

// // const fileInput = {
// //     padding: "6px",
// //     border: "1px solid #d1d5db",
// //     borderRadius: "6px",
// //     fontSize: "12px",
// //     width: "100%"
// // };

// // const licenseRow = {
// //     display: "flex",
// //     gap: "16px",
// //     alignItems: "flex-end",
// //     flexWrap: "nowrap",
// //     width: "100%",
// // };

// // const licenseItem = {
// //     flex: "1 1 33%",
// //     minWidth: width > 1300 ? "300px" : "unset",
// //     display: "flex",
// //     flexDirection: "column"
// // };

// // const fileItem = {
// //     flex: "1 1 33%",
// //     minWidth: width > 1300 ? "300px" : "unset",
// //     display: "flex",
// //     alignItems: "center",
// //     gap: "8px",
// //     minWidth: "140px"
// // };

// // const fileLabel = {
// //     fontSize: "12px",
// //     fontWeight: "600",
// //     color: "#374151"
// // };

// // const imagePreviewSmall = {
// //     width: "50px",
// //     height: "50px",
// //     objectFit: "cover",
// //     borderRadius: "6px",
// //     border: "1px solid #e5e7eb"
// // };




// import { useEffect, useState } from "react";
// import { registerVendor, updateEngineeringVendor, getEngineeringVendorById } from "../../../Service/Engineeringservicefil";
// import { useLoader } from "../../../context/LoaderProvider";

// const PreviewCard = ({ formData, onBack }) => {
//     const { showLoader, hideLoader } = useLoader();
//     const [apiData, setApiData] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);

//     const isAlreadySaved = apiData && Object.keys(apiData).length > 0;
//     const data = apiData || formData;

//     // Check if data exists and set edit mode
//     useEffect(() => {
//         const fetchVendor = async () => {
//             try {
//                 const vendorId = localStorage.getItem("vendorId");
//                 if (!vendorId) return;
                
//                 const vendorData = await getEngineeringVendorById(vendorId);
                
//                 if (vendorData && vendorData.vendorId) {
//                     setApiData({
//                         // Company
//                         companyName: vendorData.companyName,
//                         businessVertical: vendorData.businessVertical,
//                         position: vendorData.position,
//                         vendorType: vendorData.vendorType,
                        
//                         // Contact
//                         contactName: vendorData.holderName,
//                         phone: vendorData.mobileNumber,
//                         email: vendorData.email,
//                         aadhar: vendorData.aadharNumber,
//                         aadharPreview: vendorData.aadharPhotoFront,
                        
//                         // Documents
//                         gst: vendorData.gstNumber,
//                         gstFilePreview: vendorData.gstImage,
//                         pan: vendorData.panCardNumber,
//                         panFilePreview: vendorData.panCard,
//                         tradeLicenseNo: vendorData.tradeLicenseNumber,
//                         tradeStart: vendorData.tradeLicenseStartDate,
//                         tradeEnd: vendorData.tradeLicenseEndDate,
//                         tradeLicenseFilePreview: vendorData.tradeLicense,
//                         labourLicenseNo: vendorData.labourLicenseNumber,
//                         labourStart: vendorData.labourStartDate,
//                         labourEnd: vendorData.labourEndDate,
//                         labourFilePreview: vendorData.labourLicense,
//                         bankName: vendorData.bankName,
//                         ifsc: vendorData.ifscCode,
//                         accountNumber: vendorData.bankAccountNumber,
//                         passbookFilePreview: vendorData.passbookImage,
                        
//                         // Location
//                         doorNumber: vendorData.doorNumber,
//                         addressLine: vendorData.addressLine,
//                         landMark: vendorData.landMark,
//                         city: vendorData.city,
//                         state: vendorData.state,
//                         pincode: vendorData.pincode,
//                         latitude: vendorData.latitude,
//                         longitude: vendorData.longitude
//                     });
//                 }
//             } catch (err) {
//                 console.error("Error fetching data:", err);
//             }
//         };
//         fetchVendor();
//     }, []);

//     const handleSave = async () => {
//         try {
//             const vendorId = localStorage.getItem("vendorId");
//             showLoader();
            
//             const formDataToSend = new FormData();
            
//             // Check if we're updating or creating new
//             const isUpdate = isAlreadySaved;
//             setIsUpdating(isUpdate);
            
//             const vendorDataPayload = {
//                 vendorId: Number(vendorId),
//                 companyName: formData.companyName || "",
//                 businessVertical: formData.businessVertical || "ENGINEERING_SERVICE",
//                 position: formData.position || "",
//                 vendorType: formData.vendorType || "",
//                 holderName: formData.contactName || "",
//                 mobileNumber: formData.phone || "",
//                 email: formData.email || "",
//                 aadharNumber: formData.aadhar || "",
//                 panCardNumber: formData.pan || "",
//                 gstNumber: formData.gst || "",
//                 tradeLicenseNumber: formData.tradeLicenseNo || "",
//                 tradeLicenseStartDate: formData.tradeStart || "",
//                 tradeLicenseEndDate: formData.tradeEnd || "",
//                 labourLicenseNumber: formData.labourLicenseNo || "",
//                 labourStartDate: formData.labourStart || "",
//                 labourEndDate: formData.labourEnd || "",
//                 bankAccountNumber: formData.accountNumber || "",
//                 ifscCode: formData.ifsc || "",
//                 bankName: formData.bankName || "",
//                 branchName: formData.bankName || "",
//                 latitude: Number(formData.latitude) || 0,
//                 longitude: Number(formData.longitude) || 0,
//                 doorNumber: formData.doorNumber || "",
//                 addressLine: formData.addressLine || "",
//                 landMark: formData.landMark || "",
//                 city: formData.city || "",
//                 state: formData.state || "",
//                 pincode: Number(formData.pincode) || 0,
//                 fullAddress: formData.fullAddress || ""
//             };
            
//             formDataToSend.append(
//                 "vendorData",
//                 new Blob([JSON.stringify(vendorDataPayload)], { type: "application/json" })
//             );
            
//             // Append files if they exist
//             if (formData.aadharFile) formDataToSend.append("aadharPhotoFront", formData.aadharFile);
//             if (formData.panFile) formDataToSend.append("panCard", formData.panFile);
//             if (formData.gstFile) formDataToSend.append("gstImage", formData.gstFile);
//             if (formData.passbookFile) formDataToSend.append("passbookImage", formData.passbookFile);
//             if (formData.labourFile) formDataToSend.append("labourLicense", formData.labourFile);
//             if (formData.tradeLicenseFile) formDataToSend.append("tradeLicense", formData.tradeLicenseFile);
            
//             let res;
//             if (isUpdate) {
//                 // Use PUT API for update
//                 res = await updateEngineeringVendor(vendorId, formDataToSend);
//                 alert("✅ Vendor Updated Successfully");
//             } else {
//                 // Use POST API for new registration
//                 res = await registerVendor(vendorId, formDataToSend);
//                 alert("✅ Vendor Registered Successfully");
//             }
            
//             window.location.reload();
//         } catch (err) {
//             console.error(err);
//             alert("❌ Failed to save vendor data");
//         } finally {
//             hideLoader();
//             setIsUpdating(false);
//         }
//     };

//     const DetailRow = ({ label, value }) => (
//         <div style={detailItem}>
//             <label style={detailLabel}>{label}</label>
//             <div style={detailValue}>{value || "-"}</div>
//         </div>
//     );

//     const ImageRow = ({ label, src }) => (
//         <div style={detailItem}>
//             <label style={detailLabel}>{label}</label>
//             <div style={imageWrapper}>
//                 {src ? (
//                     <img src={src} alt={label} style={imagePreview} />
//                 ) : (
//                     <div style={noImage}>No image uploaded</div>
//                 )}
//             </div>
//         </div>
//     );

//     return (
//         <div style={card}>
//             <div style={previewBox}>
                
//                 {/* Company Details */}
//                 {(data.companyName || data.businessVertical || data.position || data.vendorType) && (
//                     <>
//                         <h4 style={title}>Company Details</h4>
//                         <div style={detailsGrid}>
//                             <DetailRow label="Company Name" value={data.companyName} />
//                             <DetailRow label="Business Vertical" value={data.businessVertical || "Engineering Service"} />
//                             <DetailRow label="Position" value={data.position} />
//                             <DetailRow label="Business Type" value={data.vendorType} />
//                         </div>
//                         <hr style={divider} />
//                     </>
//                 )}

//                 {/* Contact Details */}
//                 {(data.contactName || data.phone || data.email || data.aadhar) && (
//                     <>
//                         <h4 style={title}>Contact Details</h4>
//                         <div style={detailsGrid}>
//                             <DetailRow label="Contact Name" value={data.contactName} />
//                             <DetailRow label="Phone Number" value={data.phone} />
//                             <DetailRow label="Email" value={data.email} />
//                             <DetailRow label="Aadhaar Number" value={data.aadhar} />
//                             <ImageRow label="Aadhaar Document" src={data.aadharPreview} />
//                         </div>
//                         <hr style={divider} />
//                     </>
//                 )}

//                 {/* Documents & Licenses */}
//                 {(data.gst || data.pan || data.tradeLicenseNo || data.labourLicenseNo || data.bankName) && (
//                     <>
//                         <h4 style={title}>Documents & Licenses</h4>
                        
//                         {data.gst && (
//                             <div style={subSection}>
//                                 <h5 style={subTitle}>GST Details</h5>
//                                 <div style={detailsGrid}>
//                                     <DetailRow label="GST Number" value={data.gst} />
//                                     <ImageRow label="GST Document" src={data.gstFilePreview} />
//                                 </div>
//                             </div>
//                         )}

//                         {data.pan && (
//                             <div style={subSection}>
//                                 <h5 style={subTitle}>PAN Details</h5>
//                                 <div style={detailsGrid}>
//                                     <DetailRow label="PAN Number" value={data.pan} />
//                                     <ImageRow label="PAN Document" src={data.panFilePreview} />
//                                 </div>
//                             </div>
//                         )}

//                         {data.tradeLicenseNo && (
//                             <div style={subSection}>
//                                 <h5 style={subTitle}>Trade License</h5>
//                                 <div style={detailsGrid}>
//                                     <DetailRow label="License Number" value={data.tradeLicenseNo} />
//                                     <DetailRow label="Start Date" value={data.tradeStart} />
//                                     <DetailRow label="End Date" value={data.tradeEnd} />
//                                     <ImageRow label="Trade Document" src={data.tradeLicenseFilePreview} />
//                                 </div>
//                             </div>
//                         )}

//                         {data.labourLicenseNo && (
//                             <div style={subSection}>
//                                 <h5 style={subTitle}>Labour License</h5>
//                                 <div style={detailsGrid}>
//                                     <DetailRow label="License Number" value={data.labourLicenseNo} />
//                                     <DetailRow label="Start Date" value={data.labourStart} />
//                                     <DetailRow label="End Date" value={data.labourEnd} />
//                                     <ImageRow label="Labour Document" src={data.labourFilePreview} />
//                                 </div>
//                             </div>
//                         )}

//                         {data.bankName && (
//                             <div style={subSection}>
//                                 <h5 style={subTitle}>Bank Details</h5>
//                                 <div style={detailsGrid}>
//                                     <DetailRow label="Bank Name" value={data.bankName} />
//                                     <DetailRow label="IFSC Code" value={data.ifsc} />
//                                     <DetailRow label="Account Number" value={data.accountNumber} />
//                                     <ImageRow label="Passbook / Cheque" src={data.passbookFilePreview} />
//                                 </div>
//                             </div>
//                         )}

//                         <hr style={divider} />
//                     </>
//                 )}

//                 {/* Location Details (Last) */}
//                 {(data.doorNumber || data.addressLine || data.city || data.state || data.pincode) && (
//                     <>
//                         <h4 style={title}>Location Details</h4>
//                         <div style={detailsGrid}>
//                             <DetailRow label="Door No" value={data.doorNumber} />
//                             <DetailRow label="Street / Address" value={data.addressLine} />
//                             <DetailRow label="Landmark" value={data.landMark} />
//                             <DetailRow label="City" value={data.city} />
//                             <DetailRow label="State" value={data.state} />
//                             <DetailRow label="Pincode" value={data.pincode} />
//                             <DetailRow label="Latitude" value={data.latitude} />
//                             <DetailRow label="Longitude" value={data.longitude} />
//                         </div>
//                         <hr style={divider} />
//                     </>
//                 )}

//                 {/* Buttons */}
//                 <div style={buttonContainer}>
//                     <button style={backBtn} onClick={onBack}>← Back</button>
//                     <button
//                         style={{
//                             ...saveBtn,
//                             background: isAlreadySaved ? "#f97316" : "#22c55e",
//                             cursor: "pointer"
//                         }}
//                         onClick={handleSave}
//                     >
//                         {isAlreadySaved ? "Update" : "Save"}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PreviewCard;

// // Styles
// const card = { background: "#fff", borderRadius: "12px", margin: "10px" };
// const previewBox = { borderRadius: "10px", padding: "20px", color: "#6b7280" };
// const title = { fontSize: "16px", fontWeight: "600", marginBottom: "16px", color: "#111827" };
// const subTitle = { fontSize: "14px", fontWeight: "600", marginBottom: "12px", color: "#000000" };
// const subSection = { marginBottom: "20px", padding: "12px",  borderRadius: "8px" };
// const divider = { margin: "16px 0", border: "none", borderTop: "1px solid #e5e7eb" };
// const detailsGrid = { display: "grid", gridTemplateColumns: "repeat(2, minmax(280px, 1fr))", gap: "16px", marginBottom: "16px" };
// const detailItem = { display: "flex", flexDirection: "column", gap: "4px" };
// const detailLabel = { fontSize: "12px", fontWeight: "600", color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px" };
// const detailValue = { fontSize: "14px", fontWeight: "500", color: "#111827", padding: "8px 12px", background: "#f9fafb", borderRadius: "8px", border: "1px solid #e5e7eb", wordBreak: "break-word" };
// const imageWrapper = { padding: "8px 12px", background: "#f9fafb", borderRadius: "8px", border: "1px solid #e5e7eb" };
// const imagePreview = { width: "80px", height: "80px", objectFit: "cover", borderRadius: "8px", border: "1px solid #e5e7eb" };
// const noImage = { fontSize: "12px", color: "#9ca3af", fontStyle: "italic", padding: "8px" };
// const buttonContainer = { display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "24px", paddingTop: "20px", borderTop: "1px solid #e5e7eb" };
// const backBtn = { background: "#6b7280", color: "#fff", padding: "10px 24px", borderRadius: "8px", border: "none", cursor: "pointer", fontWeight: "500", fontSize: "14px" };
// const saveBtn = { padding: "10px 30px", borderRadius: "8px", border: "none", fontWeight: "600", cursor: "pointer", fontSize: "14px", transition: "0.2s", color: "#fff" };


import { useEffect, useState } from "react";
import { registerVendor, updateEngineeringVendor, getEngineeringVendorById } from "../../../Service/Engineeringservicefil";
import { useLoader } from "../../../context/LoaderProvider";

const PreviewCard = ({ formData, onBack }) => {
    const { showLoader, hideLoader } = useLoader();
    const [apiData, setApiData] = useState(null);
    const [isUpdating, setIsUpdating] = useState(false);

    const isAlreadySaved = apiData && Object.keys(apiData).length > 0;
    const data = apiData || formData;

    // Helper function to extract filename from URL
    const getFileNameFromUrl = (url) => {
        if (!url) return null;
        try {
            // Extract filename from URL
            const urlParts = url.split('/');
            let filename = urlParts[urlParts.length - 1];
            // Remove query parameters
            filename = filename.split('?')[0];
            // Decode URI component
            filename = decodeURIComponent(filename);
            // Truncate if too long
            if (filename.length > 30) {
                filename = filename.substring(0, 27) + '...';
            }
            return filename;
        } catch (e) {
            return "Document";
        }
    };

    // Check if data exists and set edit mode
    useEffect(() => {
        const fetchVendor = async () => {
            try {
                const vendorId = localStorage.getItem("vendorId");
                if (!vendorId) return;
                
                const vendorData = await getEngineeringVendorById(vendorId);
                
                if (vendorData && vendorData.vendorId) {
                    setApiData({
                        // Company
                        companyName: vendorData.companyName,
                        businessVertical: vendorData.businessVertical,
                        position: vendorData.position,
                        vendorType: vendorData.vendorType,
                        
                        // Contact
                        contactName: vendorData.holderName,
                        phone: vendorData.mobileNumber,
                        email: vendorData.email,
                        aadhar: vendorData.aadharNumber,
                        aadharPreview: vendorData.aadharPhotoFront,
                        
                        // Documents
                        gst: vendorData.gstNumber,
                        gstFilePreview: vendorData.gstImage,
                        pan: vendorData.panCardNumber,
                        panFilePreview: vendorData.panCard,
                        tradeLicenseNo: vendorData.tradeLicenseNumber,
                        tradeStart: vendorData.tradeLicenseStartDate,
                        tradeEnd: vendorData.tradeLicenseEndDate,
                        tradeLicenseFilePreview: vendorData.tradeLicense,
                        labourLicenseNo: vendorData.labourLicenseNumber,
                        labourStart: vendorData.labourStartDate,
                        labourEnd: vendorData.labourEndDate,
                        labourFilePreview: vendorData.labourLicense,
                        bankName: vendorData.bankName,
                        ifsc: vendorData.ifscCode,
                        accountNumber: vendorData.bankAccountNumber,
                        passbookFilePreview: vendorData.passbookImage,
                        
                        // Location
                        doorNumber: vendorData.doorNumber,
                        addressLine: vendorData.addressLine,
                        landMark: vendorData.landMark,
                        city: vendorData.city,
                        state: vendorData.state,
                        pincode: vendorData.pincode,
                        latitude: vendorData.latitude,
                        longitude: vendorData.longitude
                    });
                }
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };
        fetchVendor();
    }, []);

    const handleSave = async () => {
        try {
            const vendorId = localStorage.getItem("vendorId");
            showLoader();
            
            const formDataToSend = new FormData();
            
            const isUpdate = isAlreadySaved;
            setIsUpdating(isUpdate);
            
            const vendorDataPayload = {
                vendorId: Number(vendorId),
                companyName: formData.companyName || "",
                businessVertical: formData.businessVertical || "ENGINEERING_SERVICE",
                position: formData.position || "",
                vendorType: formData.vendorType || "",
                holderName: formData.contactName || "",
                mobileNumber: formData.phone || "",
                email: formData.email || "",
                aadharNumber: formData.aadhar || "",
                panCardNumber: formData.pan || "",
                gstNumber: formData.gst || "",
                tradeLicenseNumber: formData.tradeLicenseNo || "",
                tradeLicenseStartDate: formData.tradeStart || "",
                tradeLicenseEndDate: formData.tradeEnd || "",
                labourLicenseNumber: formData.labourLicenseNo || "",
                labourStartDate: formData.labourStart || "",
                labourEndDate: formData.labourEnd || "",
                bankAccountNumber: formData.accountNumber || "",
                ifscCode: formData.ifsc || "",
                bankName: formData.bankName || "",
                branchName: formData.bankName || "",
                latitude: Number(formData.latitude) || 0,
                longitude: Number(formData.longitude) || 0,
                doorNumber: formData.doorNumber || "",
                addressLine: formData.addressLine || "",
                landMark: formData.landMark || "",
                city: formData.city || "",
                state: formData.state || "",
                pincode: Number(formData.pincode) || 0,
                fullAddress: formData.fullAddress || ""
            };
            
            formDataToSend.append(
                "vendorData",
                new Blob([JSON.stringify(vendorDataPayload)], { type: "application/json" })
            );
            
            if (formData.aadharFile) formDataToSend.append("aadharPhotoFront", formData.aadharFile);
            if (formData.panFile) formDataToSend.append("panCard", formData.panFile);
            if (formData.gstFile) formDataToSend.append("gstImage", formData.gstFile);
            if (formData.passbookFile) formDataToSend.append("passbookImage", formData.passbookFile);
            if (formData.labourFile) formDataToSend.append("labourLicense", formData.labourFile);
            if (formData.tradeLicenseFile) formDataToSend.append("tradeLicense", formData.tradeLicenseFile);
            
            if (isUpdate) {
                await updateEngineeringVendor(vendorId, formDataToSend);
                alert("✅ Vendor Updated Successfully");
            } else {
                await registerVendor(vendorId, formDataToSend);
                alert("✅ Vendor Registered Successfully");
            }
            
            window.location.reload();
        } catch (err) {
            console.error(err);
            alert("❌ Failed to save vendor data");
        } finally {
            hideLoader();
            setIsUpdating(false);
        }
    };

    const DetailRow = ({ label, value }) => (
        <div style={detailItem}>
            <label style={detailLabel}>{label}</label>
            <div style={detailValue}>{value || "-"}</div>
        </div>
    );

    // New component to show file name with green tick
    const FileRow = ({ label, fileUrl }) => {
        const fileName = getFileNameFromUrl(fileUrl);
        
        if (!fileUrl) return null;
        
        return (
            <div style={detailItem}>
                <label style={detailLabel}>{label}</label>
                <div style={fileValue}>
                    <span style={tickMark}>✓</span>
                    <span style={fileNameText}>{fileName}</span>
                </div>
            </div>
        );
    };

    return (
        <div style={card}>
            <div style={previewBox}>
                
                {/* Company Details */}
                {(data.companyName || data.businessVertical || data.position || data.vendorType) && (
                    <>
                        <h4 style={title}>Company Details</h4>
                        <div style={detailsGrid}>
                            <DetailRow label="Company Name" value={data.companyName} />
                            <DetailRow label="Business Vertical" value={data.businessVertical || "Engineering Service"} />
                            <DetailRow label="Position" value={data.position} />
                            <DetailRow label="Business Type" value={data.vendorType} />
                        </div>
                        <hr style={divider} />
                    </>
                )}

                {/* Contact Details */}
                {(data.contactName || data.phone || data.email || data.aadhar) && (
                    <>
                        <h4 style={title}>Contact Details</h4>
                        <div style={detailsGrid}>
                            <DetailRow label="Contact Name" value={data.contactName} />
                            <DetailRow label="Phone Number" value={data.phone} />
                            <DetailRow label="Email" value={data.email} />
                            <DetailRow label="Aadhaar Number" value={data.aadhar} />
                            <FileRow label="Aadhaar Document" fileUrl={data.aadharPreview} />
                        </div>
                        <hr style={divider} />
                    </>
                )}

                {/* Documents & Licenses */}
                {(data.gst || data.pan || data.tradeLicenseNo || data.labourLicenseNo || data.bankName) && (
                    <>
                        <h4 style={title}>Documents & Licenses</h4>
                        
                        {data.gst && (
                            <div style={subSection}>
                                <h5 style={subTitle}>GST Details</h5>
                                <div style={detailsGrid}>
                                    <DetailRow label="GST Number" value={data.gst} />
                                    <FileRow label="GST Document" fileUrl={data.gstFilePreview} />
                                </div>
                            </div>
                        )}

                        {data.pan && (
                            <div style={subSection}>
                                <h5 style={subTitle}>PAN Details</h5>
                                <div style={detailsGrid}>
                                    <DetailRow label="PAN Number" value={data.pan} />
                                    <FileRow label="PAN Document" fileUrl={data.panFilePreview} />
                                </div>
                            </div>
                        )}

                        {data.tradeLicenseNo && (
                            <div style={subSection}>
                                <h5 style={subTitle}>Trade License</h5>
                                <div style={detailsGrid}>
                                    <DetailRow label="License Number" value={data.tradeLicenseNo} />
                                    <DetailRow label="Start Date" value={data.tradeStart} />
                                    <DetailRow label="End Date" value={data.tradeEnd} />
                                    <FileRow label="Trade Document" fileUrl={data.tradeLicenseFilePreview} />
                                </div>
                            </div>
                        )}

                        {data.labourLicenseNo && (
                            <div style={subSection}>
                                <h5 style={subTitle}>Labour License</h5>
                                <div style={detailsGrid}>
                                    <DetailRow label="License Number" value={data.labourLicenseNo} />
                                    <DetailRow label="Start Date" value={data.labourStart} />
                                    <DetailRow label="End Date" value={data.labourEnd} />
                                    <FileRow label="Labour Document" fileUrl={data.labourFilePreview} />
                                </div>
                            </div>
                        )}

                        {data.bankName && (
                            <div style={subSection}>
                                <h5 style={subTitle}>Bank Details</h5>
                                <div style={detailsGrid}>
                                    <DetailRow label="Bank Name" value={data.bankName} />
                                    <DetailRow label="IFSC Code" value={data.ifsc} />
                                    <DetailRow label="Account Number" value={data.accountNumber} />
                                    <FileRow label="Passbook / Cheque" fileUrl={data.passbookFilePreview} />
                                </div>
                            </div>
                        )}

                        <hr style={divider} />
                    </>
                )}

                {/* Location Details (Last) */}
                {(data.doorNumber || data.addressLine || data.city || data.state || data.pincode) && (
                    <>
                        <h4 style={title}>Location Details</h4>
                        <div style={detailsGrid}>
                            <DetailRow label="Door No" value={data.doorNumber} />
                            <DetailRow label="Street / Address" value={data.addressLine} />
                            <DetailRow label="Landmark" value={data.landMark} />
                            <DetailRow label="City" value={data.city} />
                            <DetailRow label="State" value={data.state} />
                            <DetailRow label="Pincode" value={data.pincode} />
                            <DetailRow label="Latitude" value={data.latitude} />
                            <DetailRow label="Longitude" value={data.longitude} />
                        </div>
                    </>
                )}

                {/* Buttons */}
                <div style={buttonContainer}>
                    <button style={backBtn} onClick={onBack}>← Back</button>
                    <button
                        style={{
                            ...saveBtn,
                            background: isAlreadySaved ? "#f97316" : "#22c55e",
                            cursor: "pointer"
                        }}
                        onClick={handleSave}
                    >
                        {isAlreadySaved ? "Update" : "Save"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PreviewCard;

// Styles
const card = { background: "#fff", borderRadius: "12px", margin: "10px" };
const previewBox = { borderRadius: "10px", padding: "20px", color: "#6b7280" };
const title = { fontSize: "16px", fontWeight: "600", marginBottom: "16px", color: "#111827" };
const subTitle = { fontSize: "14px", fontWeight: "600", marginBottom: "12px", color: "#000000" };
const subSection = { marginBottom: "0px", padding: "12px", borderRadius: "8px" };
const divider = { margin: "16px 0", border: "none", borderTop: "1px solid #e5e7eb" };
const detailsGrid = { display: "grid", gridTemplateColumns: "repeat(2, minmax(280px, 1fr))", gap: "16px", marginBottom: "0px" };
const detailItem = { display: "flex", flexDirection: "column", gap: "4px" };
const detailLabel = { fontSize: "12px", fontWeight: "600", color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px" };
const detailValue = { fontSize: "14px", fontWeight: "500", color: "#111827", padding: "8px 12px", background: "#f9fafb", borderRadius: "8px", border: "1px solid #e5e7eb", wordBreak: "break-word" };

// New styles for file display with green tick
const fileValue = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    background: "#f0fdf4",
    borderRadius: "8px",
    border: "1px solid #bbf7d0",
    wordBreak: "break-word"
};

const tickMark = {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#22c55e",
    background: "#dcfce7",
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
};

const fileNameText = {
    fontSize: "13px",
    fontWeight: "500",
    color: "#166534",
    fontFamily: "monospace"
};

const buttonContainer = { display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "24px", paddingTop: "20px", borderTop: "1px solid #e5e7eb" };
const backBtn = { background: "#6b7280", color: "#fff", padding: "10px 24px", borderRadius: "8px", border: "none", cursor: "pointer", fontWeight: "500", fontSize: "14px" };
const saveBtn = { padding: "10px 30px", borderRadius: "8px", border: "none", fontWeight: "600", cursor: "pointer", fontSize: "14px", transition: "0.2s", color: "#fff" };